/**
 * Whether the floating Jump anchor shows: at least one purchasable jump
 * point pill is not fully visible in the viewport — whether it sits below
 * or scrolled above. No purchasable pills → never show.
 *
 * A score with no measurement yet counts as fully visible, so the anchor
 * never flashes in before the first IntersectionObserver callback. Stale
 * measurements for scores that are no longer purchasable are ignored.
 */
export function shouldShowJumpAnchor(
  purchasableScores: readonly number[],
  isFullyVisibleByScore: ReadonlyMap<number, boolean>,
): boolean {
  return purchasableScores.some(
    (score) => isFullyVisibleByScore.get(score) === false,
  )
}
